var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vuestic-dropdown",
    { staticClass: "form-group", attrs: { placement: "bottom" } },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-primary btn-sm dropdown-toggle",
          attrs: { slot: "actuator", type: "button" },
          slot: "actuator",
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.selected) + " " + _vm._s(_vm.label) + "\n    "
          ),
          _c("i", { staticClass: "ion-ios-arrow-down arrow-down" }),
        ]
      ),
      _vm._l(_vm.options, function (option, index) {
        return _c(
          "a",
          {
            key: index,
            staticClass: "dropdown-item",
            on: {
              click: function ($event) {
                return _vm.selectedItemsPerPage(option.value)
              },
            },
          },
          [_vm._v("\n      " + _vm._s(option.value) + " per page\n    ")]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }